import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Select } from 'components/forms'
import listCreditClients from 'sections/creditClient/gql/listCreditClients'
import { useQuery } from 'components/graphql'
import Button from 'components/Button'

const ERP = ({ formData, updateItem }) => {
	const [t] = useTranslation()
	const { data, loading } = useQuery(listCreditClients, { fetchPolicy: 'cache-and-network' })
	const options = data.listCreditClients?.items || []
	const [ids, setIds] = useState(formData.creditClientsId || [])

	const handleAdd = () => {
		setIds([...ids, null])
	}

	return (
		<Form
			initialValues={formData}
			onSubmit={updateItem}
			smartSubmit
		>
			<>
				{ids.map((_, index) => (
					<Select
						key={index}
						field={`creditClientsId[${index}]`}
						isClearable
						label={t('options_section.fields.standard_credit_customer', { num: index + 1 })}
						valueField='id'
						labelField='name'
						simpleValue
						isLoading={loading}
						isSearchable
						options={options}
					/>
				))}
				<Button
					status='primary'
					text={t('common.strings.new')}
					onClick={handleAdd}
				/>
			</>
		</Form>
	)
}

export default ERP
